import styled from 'styled-components';
import {
    blue01,
    blueDark01,
    blueDark02,
    blueLink,
    grayDark05,
    grayDark06,
    grayLight02,
    grayLight03,
    orange,
    orange01,
    orange02,
} from '../../../../../styles/colors';
import { PrimaryButton, Tag } from '../../../../../styles/common.styles';
import { Select } from 'antd';

export const GuidelineInformationContainer = styled.div`
    max-width: 2000px;
    padding: 40px 100px 60px 100px;
    @media screen and (max-width: 760px) {
        padding: 40px 30px 60px 30px;
    }
`;

export const GuidelineInformationLayout = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    align-items: start;

    @media screen and (max-width: 900px) {
        grid-template-columns: 1fr;
    }
`;

export const OwnerTag = styled(Tag)`
    background: transparent;
    border: 0;
    border-radius: 0;
    padding: 0;
    font-size: 13px;
    font-family: 'Proxima Nova';
    font-weight: 400;
    line-height: 16px;
    display: inline-flex;
    align-items: center;
    height: auto;
    margin: 0;

    .ant-tag-close-icon {
        position: relative;
        display: inline-flex;
        align-items: center;
        color: ${blueLink};
        cursor: pointer;

        &::after {
            position: absolute;
            right: 0;
            bottom: -1px;
            left: 0;
            border-bottom: 1px solid ${blueLink};
            content: '';
            opacity: 0;
        }

        &:hover::after {
            opacity: 1;
        }
    }
`;

export const OwnersList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const AddOwnerRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
`;

export const LeftColumn = styled.div`
    display: flex;
    flex-direction: column;
`;

export const RightColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 28px;
`;

export const DescriptionInformationSection = styled.div`
    display: flex;
    flex-direction: column;
`;

export const BasicInformationSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 40px;
`;

export const SearchCriteriaSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 24px;
`;

export const SectionTitle = styled.div`
    font-family: 'DIN Next W01 Medium';
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    color: ${blue01};
    margin-bottom: 12px;
`;

export const SearchCriteriaSectionTitle = styled(SectionTitle)`
    margin-bottom: 0px;
`;

export const FieldRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 16px;
`;

export const FieldInput = styled.div`
    width: 286px;
    height: 36px;

    .ant-input {
        width: 286px;
        height: 36px;
    }
`;

export const FieldLabel = styled.span`
    font-family: 'Proxima N W15 Bold';
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: ${blueDark01};
    width: 100px;
    max-width: 100px;
    white-space: normal;
    overflow-wrap: anywhere;
    text-align: right;
`;

export const FieldValue = styled.span`
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: ${blueLink};
`;

export const FilterContainer = styled.div`
    width: 100%;
    display: flex;
    gap: 16px;
    flex-direction: row;
    align-items: center;
`;

export const OwnersSelect = styled(Select)`
    width: 286px !important;
    height: 36px !important;

    .ant-select-selector {
        width: 286px !important;
        height: 36px !important;
    }
`;

export const CriteriaSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const CriteriaHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const CriteriaGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const CriteriaGroupTitle = styled.div`
    font-family: 'DIN Next W01 Medium';
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    color: ${blue01};
`;

export const CriteriaGroupValue = styled.div`
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: ${blueDark01};
    font-family: 'Proxima Nova';
`;

export const CriteriaGroupLabel = styled.span`
    font-family: 'Proxima N W15 Bold';
`;

export const LastUpdatedText = styled.span`
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: ${blueDark01};
`;

export const SaveButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 24px;
`;

export const DescriptionTextArea = styled.div`
    width: 100%;

    .ant-form-item-label > label {
        font-family: 'Proxima N W15 Bold';
        font-size: 13px;
        color: ${blueDark01};
    }

    .ant-input {
        width: 100%;
    }
`;

export const EditCriteriaButton = styled.div`
    display: inline-flex;
`;

export const SaveButton = styled(PrimaryButton)`
    cursor: pointer;
    background-color: ${orange01};
    color: #ffff;
    border-radius: 3px;
    border: none;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    height: 28px;
    font-family: 'DINNextLTPro';
    padding: 5px 10px;
    min-width: 112px;

    &:hover {
        background-color: ${orange02};
        color: #ffffff;
    }

    &:focus {
        background-color: ${orange};
        color: #ffff;
    }
`;

export const AddButton = styled(PrimaryButton)`
    width: 52px;
    height: 36px;
    padding: 0;
    cursor: pointer;
    background-color: transparent;
    color: ${blueDark02};
    border-radius: 3px;
    border: 1px solid ${blueDark02};
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    font-family: 'DINNextLTPro';

    &&:disabled,
    &&:disabled:hover,
    &&:disabled:focus,
    &&:disabled:active {
        opacity: 1;
        background-color: ${grayLight03};
        color: ${grayDark05};
        border: 1px solid ${grayDark06};
        box-shadow: none;
        cursor: not-allowed;
    }
`;

export const BasicInfoDivider = styled.div`
    height: 1px;
    background: ${grayLight02};
    margin: 40px 0 24px 0;
`;
